export default __webpack_public_path__ + "14fc9d845bff5fefbf290356af7f33a2.svg";